export default __webpack_public_path__ + "static/media/桃花.c0a79696.svg";